<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import RealEstateCommissionSheetDeliveryStatus from './RealEstateCommissionSheetDeliveryStatus.vue';

defineProps({
  activeGroupIndex: { type: Number, default: 0 },
  canDownload: { type: Boolean, default: false },
  canSend: { type: Boolean, default: false },
  downloading: { type: Boolean, default: false },
  isLastGroup: { type: Boolean, default: false },
  preview: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
  sent: { type: Boolean, default: false },
  sentAt: { type: String, default: '' },
});

const emit = defineEmits(['download', 'next', 'preview', 'previous', 'send']);
const { t } = useI18n();
</script>

<template>
  <footer
    class="fixed inset-x-0 bottom-0 z-20 flex flex-wrap items-center justify-end gap-3 border-t border-lais-border bg-white px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] shadow-lais-pop sm:px-6 lg:px-10"
  >
    <RealEstateCommissionSheetDeliveryStatus
      v-if="preview"
      class="mr-auto"
      :can-download="canDownload"
      :downloading="downloading"
      :sent-at="sentAt"
      @download="emit('download')"
    />
    <LaisPrimaryButton
      v-if="!preview && activeGroupIndex > 0"
      variant="ghost"
      icon="i-lucide-arrow-left"
      :disabled="saving"
      @click="emit('previous')"
    >
      {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.PREVIOUS') }}
    </LaisPrimaryButton>
    <LaisPrimaryButton
      v-if="!preview"
      variant="ghost"
      :icon="isLastGroup ? 'i-lucide-eye' : 'i-lucide-arrow-right'"
      :disabled="saving"
      @click="isLastGroup ? emit('preview') : emit('next')"
    >
      {{
        isLastGroup
          ? t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.PREVIEW')
          : t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.NEXT')
      }}
    </LaisPrimaryButton>
    <LaisPrimaryButton
      v-else-if="!sent"
      icon="i-lucide-send"
      :disabled="!canSend"
      @click="emit('send')"
    >
      {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.SEND') }}
    </LaisPrimaryButton>
  </footer>
</template>
